var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMdiAlertOctagon2F7E6F0F(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83333 8.83333H7.16667V3.83333H8.83333V8.83333ZM7.16667 10.5H8.83333V12.1667H7.16667V10.5ZM11.1083 0.5H4.89167L0.5 4.89167V11.1083L4.89167 15.5H11.1083L15.5 11.1083V4.89167L11.1083 0.5Z",
    fill: "#F2C94C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMdiAlertOctagon2F7E6F0F);
export default __webpack_public_path__ + "static/media/ic-mdi-alert-octagon.2f7e6f0f.2f7e6f0fe88d569f63c9e6f0f88fb3b1.svg";
export { ForwardRef as ReactComponent };